import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class PrefillMooImprovementsAllWeeksFeature implements IFlagFeature {
  name = Features.PREFILL_MOO_IMPROVEMENTS_ALL_WEEKS;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
